// stepFourValidation.js
import * as Yup from 'yup';

export const stepFourSchema = Yup.object().shape({
  monthly_income: Yup.string()
    .required('Monthly Income is required'),
  rent_own: Yup.string()
    .required('Rent or Own is required')
    .oneOf(
      ['Own Outright', 'Rent', 'Buying/Mortgage', 'Living with parents', 'Others'],
      'Invalid option selected for home status'
    ),
  monthly_home_payment: Yup.string().when('rent_own', {
    is: (val) => ['Rent', 'Buying/Mortgage', 'Own Outright'].includes(val),
    then: (schema) => schema.required('Monthly Rent/Mortgage Payment is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  other_expenses: Yup.string(),
});